import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { H5, P } from "../../../../../AbstractElements";
import { TotalSalesData } from "../../../../../Data/General/Dashboard/ECommerce";

const TotalSales = () => {
  return (
    <>
      {TotalSalesData.map((item, index) => {
        return (
          <Col xl="3" lg="3" md="6" sm="6" key={index}>
            <Card className="sale-chart">
              <CardBody>
                <div className="d-flex">
                  <div className="flex-shrink-0">
                    <div className="sale-detail">
                      <div className={`icon bg-light-${item.color}`}>{item.icon}</div>
                      <div className="sale-content">
                        <H5 className={`txt-${item.color}`}>{item.title}</H5>
                        <P>{item.text}</P>
                      </div>
                    </div>
                  </div>
                  <div className={`small-chart-view ${item.chartClass}`} id={item.chartClass}>
                    <ReactApexChart type={item.chart.chart?.type} options={item.chart} series={item.chart.series} height={item.chart.chart?.height} />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </>
  );
};

export default TotalSales;
